import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Button from 'antd/lib/button';
import Table from 'antd/lib/table';
import Select from 'antd/lib/select';

const Option = Select.Option;

/**
 * Props contract (container must provide):
 *  - banksMain: Array<{ code: string, name: string, logo?: string }>
 *  - banksOther: Array<{ code: string, name: string }>
 *  - onStartPsd2: function(bankCode: string)
 *  - onSkipToManual: function()
 *  - onContinueAfterSuccess: function()
 *  - lastResult: 'idle' | 'success' | 'error'
 *  - isStarting?: boolean — disable UI while we redirect/initiate
 */
@translate()
export default class Psd2BankConnect extends Component {
  static propTypes = {
    banksMain: PropTypes.array.isRequired,
    banksOther: PropTypes.array.isRequired,
    onStartPsd2: PropTypes.func.isRequired,
    onSkipToManual: PropTypes.func.isRequired,
    onContinueAfterSuccess: PropTypes.func.isRequired,
    lastResult: PropTypes.oneOf(['idle', 'success', 'error']),
    isStarting: PropTypes.bool,
    importedAccounts: PropTypes.array,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    banksMain: [],
    banksOther: [],
    lastResult: 'idle',
    isStarting: false,
    importedAccounts: [],
  };

  state = {
    selectedOtherBank: undefined,
  };

  handleOtherBankChange = (value) => {
    this.setState({ selectedOtherBank: value });
    if (value) {
      this.props.onStartPsd2(value);
    }
  };

  renderBankTile = (bank) => {
    const { isStarting } = this.props;
    return (
      <Col xs={6} sm={4} md={2} key={bank.code}>
        <Button
          className="bank-tile"
          onClick={() => this.props.onStartPsd2(bank.code)}
          disabled={isStarting}
          style={{ width: '100%', height: 180, marginBottom: 12 }}
        >
          {bank.logo ? (
            <img src={bank.logo} alt={bank.name} style={{ maxHeight: 80, maxWidth: '100%' }} />
          ) : (
            <span>{bank.name}</span>
          )}
        </Button>
      </Col>
    );
  };

  renderImportedAccounts = () => {
    const { t, importedAccounts } = this.props;
    if (!importedAccounts || importedAccounts.length === 0) return null;

    const columns = [
      { title: t('Banka'), dataIndex: 'bankName', key: 'bankName' },
      { title: t('IBAN'), dataIndex: 'iban', key: 'iban' },
    ];

    return (
      <div style={{ marginBottom: 24 }}>
        <h3>{t('Overené bankové účty')}</h3>
        <Table
          dataSource={importedAccounts}
          columns={columns}
          pagination={false}
          size="small"
          rowKey="iban"
        />
      </div>
    );
  };

  renderSuccess = () => {
    const { t, onContinueAfterSuccess } = this.props;
    return (
      <div className="psd2-success">
        {this.renderImportedAccounts()}
        <p>
          {t('Ak máte ďalšie bankové účty, doplňte ich.')}
        </p>
        <Button type="primary" onClick={onContinueAfterSuccess}>
          {t('Nemám ďalšie účty a chcem pokračovať')}
        </Button>
      </div>
    );
  };

  render() {
    const { t, banksMain, banksOther, onSkipToManual, lastResult, isStarting } = this.props;

    return (
      <section className="psd2-connect">
        <h2>{t('Overenie bankového účtu (PSD2)')}</h2>

        {lastResult !== 'success' ? this.renderImportedAccounts() : null}

        {lastResult === 'success' ? (
          this.renderSuccess()
        ) : null}
          <div>
            <p style={{ marginTop: 16 }}>
              {t('Pre online autorizované overenie vyberte banku, v ktorej sa nachádza Váš účet:')}
            </p>

            <Row>
              {banksMain.map(this.renderBankTile)}
            </Row>

            <div style={{ marginTop: 12 }}>
              <label style={{ display: 'block', marginBottom: 6 }}>{t('Ďalšie banky')}</label>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder={t('Vyberte banku')}
                optionFilterProp="children"
                onChange={this.handleOtherBankChange}
                value={this.state.selectedOtherBank}
                disabled={isStarting}
              >
                {banksOther.map(b => (
                  <Option value={b.code} key={b.code}>{b.name}</Option>
                ))}
              </Select>
            </div>

            <div style={{ marginTop: 20 }}>
              <Button onClick={onSkipToManual}>
                {t('Moja banka sa v zozname nenachádza alebo chcem výpisy nahrať manuálne')}
              </Button>
            </div>
          </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/psd2/components/Psd2BankConnect.js